import {EventEmitter, EventSubscriber, HasEventName} from "@/modules/base/events";
import {inject, injectable} from "inversify";
import {Player} from "@/modules/team/entity";
import {AfterDayEvaluationEvent} from "@/modules/season/events/AfterDayEvaluationEvent";
import {ConfigRepository} from "@/modules/base/services/ConfigRepository";

@injectable()
export class PlayerSkillReductionEventSubscriber implements EventSubscriber {
  constructor(
    @inject(ConfigRepository) private configRepository: ConfigRepository,
    @inject(EventEmitter) private eventEmitter: EventEmitter,
  ) {
  }

  priority(): number {
    return 0;
  }

  init(): { event: HasEventName; callback: (event: any) => void }[] {
    return [
      {event: AfterDayEvaluationEvent, callback: this.onAfterDayEvaluationEvent},
    ];
  }

  async onAfterDayEvaluationEvent(event: AfterDayEvaluationEvent) {
    await (
      await Player
        .createQueryBuilder('player')
        .where(
          'player.id % 28 = :currentDay',
          {currentDay: event.season.currentDate.date() - 1}
        )
        .getMany()
    )
      .forEachAsync(async (p: Player) => {
        const newSkill = this.configRepository.get('players.progress.ageSkillReduction')(p);

        if (p.skill !== newSkill) {
          const beforeSkill = p.skill;
          p.skill = newSkill;
          await p.save();

          console.debug(`skill reduced for player`, {player: p, from: beforeSkill, to: p.skill});
        }
      });
  }
}